module.exports = __webpack_public_path__ + "images/greenlab-61f6e8dc9fbc4c9031189308dd93ac2e.jpg";